import React, { useContext, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import loadable from '@loadable/component';
import sendRecentSearchData from 'MMT-UI/recentSearch';
import ModifySearch from '../../../../../../common/component/ModifySearch';
import SelectCity from '../../../../../../common/component/ModifySearch/SelectCity';
import SelectDate from '../../../../../../common/component/ModifySearch/SelectDate';
import themeContext from '../../../../../../common/context/themeContext';
import { setCityAction, setTravelDateAction } from '../../../../../redux/actions/searchActions';
import {
  convertRoomForUrl,
  getOmniturePageName,
  getRoomFromParams,
} from '../../../../../../common/utils/formattingUtils';
import SelectPax from '../../../../../../common/component/ModifySearch/SelectPax';
import SelectCityWithLocation from '../../../../../../common/component/ModifySearch/SelectCityWithLocation';
import { getMMT_HLD_OBJ } from '../../../../../../common/utils/appUtils';
import { FROM_MANUAL } from '../../../../../../common/component/ModifySearch/constants';
import { getTotalPaxCount } from '../../../../../../common/component/ModifySearch/utils';
import {
  getUrlParamsMapV2,
  isAgentLoggedIn,
  getUrlParamsMap,
  dateFormatter,
  getQueryStr,
  isMobile as isMobileDevice,
} from '../../../../../../common/utils/browserUtils';
import { getLocationEvarValue } from '../../../../../../common/component/ModifySearch/SelectCityWithLocation/LocationModalHelper';
import { setRecentSearch } from '../../../../../../common/utils/searchUtils';
import getLandingMetaData from '../../../../../redux/services/landingMetadataService';
import { getFromCities } from '../../../../../helpers/utils';
import { LISTING_PAGE_NAME } from '../../../../../redux/constants/searchConstants';
import OmnitureUtils from '../../../../../../common/utils/Omniture/OmnitureUtils';
import { TRACK_TYPE } from '../../../../../../common/constants/scriptConstant';
import { gtmClick } from '../../../../../helpers/gtmTrackingUtils';
import {
  faOnDateFocus,
  faOnDateSelect,
  faOnDestCityFocus,
  faOnDestCityOnNext,
  faOnDestCitySelect,
  faOnFromCityFocus,
  faOnFromCityOnNext,
  faOnFromCitySelect,
  faOnPaxFocus,
  faOnPaxSelect,
  faOnSearchApply,
} from '../../analytics-services';
import '../ModifySearchContainer.css';
import Analytics from '../../../../../../../analytics';
import SelectDestination from '../../../../../../common/component/ModifySearch/DestSearch/SelectDestination';

const omniture = {
  // eslint-disable-next-line max-params
  captureOmnitureClick: (prop54, _, __, ___, extraParams = {}) => {
    const omnitureParams = { prop54 };
    if (extraParams?.eVar77) {
      omnitureParams.eVar77 = extraParams?.eVar77;
    }
    if (extraParams?.eVar49) {
      omnitureParams.eVar49 = extraParams?.eVar49;
    }
    if (extraParams?.prop1) {
      omnitureParams.prop1 = extraParams?.prop1;
    }
    OmnitureUtils.trackClickEvent(omnitureParams);
  },
};

const DEFAULT_SEARCH_PAX_STRING = '2,0,0,0,,,';

const getPaxInfo = paxString => {
  const roomsList = getRoomFromParams(paxString);
  const adultCount = roomsList.reduce((sum, room) => room.noOfAdults + sum, 0);
  const childCount = roomsList.reduce(
    (sum, room) => room.noOfChildrenWB + room.noOfChildrenWOB + sum,
    0
  );
  const infantCount = roomsList.reduce((sum, room) => room.noOfInfants + sum, 0);

  return { adultCount, childCount, infantCount };
};

const ModifySearchForm = props => {
  const {
    search,
    isMobile,
    packageCount,
    modifySearchActive,
    handleMFS,
    handleCloseMFS,
    apWindow,
    metadata,
  } = props;
  const departureCity = search.default.fromCity;
  const departureDate = search.default.travelDate;
  const rooms = search.default.roomGuest;
  const departureCities = getFromCities(search.list.fromCities);
  const searchEnabled = search.default.fromCity !== '' && search.default.destValue !== '';
  const { affiliateDetails } = useContext(themeContext);
  const [destData, setDestData] = useState({
    destCity: search.default.toCity,
    destValue: search.default.destValue,
  });
  const [fromCityData, setFromCityData] = useState({});
  const [paxInfo, setPaxInfo] = useState(rooms);
  const [dateData, setDateData] = useState({ msg: '', availableDates: [] });
  const destinationCity = destData.destValue;
  const urlParams = getUrlParamsMapV2();
  const goeLocationPokus = urlParams?.glp
    ? urlParams.glp === 'true'
    : getMMT_HLD_OBJ().showGeoLocation;

  useEffect(() => {
    setDestData({
      destCity: search.default.toCity,
      destValue: search.default.destValue,
    });
  }, [search.default.destValue]);
  const oneHour = 60 * 60 * 1000;
  const oneDay = 24 * oneHour;
  const addDays = (date, days) => new Date(date?.getTime() || 0 + oneDay * days);

  useEffect(() => {
    async function sendRecentSearch() {
      if (packageCount && !isAgentLoggedIn()) {
        const roomsList = getRoomFromParams(urlParams.rooms || DEFAULT_SEARCH_PAX_STRING);
        const adultCount = roomsList.reduce((sum, room) => room.noOfAdults + sum, 0);
        const childCount = roomsList.reduce(
          (sum, room) => room.noOfChildrenWB + room.noOfChildrenWOB + sum,
          0
        );
        const infantCount = roomsList.reduce((sum, room) => room.noOfInfants + sum, 0);
        let recentSearchData = null;
        let date = '';
        let getDate = '';
        let getMonth = '';
        let getFullYear = '';
        if (departureDate) {
          date = new Date(departureDate.toString());
          getDate = date.getDate();
          getMonth = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
          getFullYear = date.getFullYear();
        }
        try {
          const expiryDate = departureDate ? addDays(new Date(departureDate), -apWindow) : null;

          recentSearchData = await sendRecentSearchData([
            {
              column: 'holidays',
              searchContext: {
                from: {
                  lobCity: departureCity,
                  cityName: departureCity,
                  lobCountry: metadata?.destinationMeta?.departureCity?.locationDetails?.country || '',
                  countryCode: metadata?.destinationMeta?.departureCity?.locationDetails?.country_code || '',
                  locusV2Id: metadata?.destinationMeta?.departureCity?.locusDetails?.locusCode || '',
                  locusV2Type: metadata?.destinationMeta?.departureCity?.locusDetails?.locusType || '',
                  name: metadata?.destinationMeta?.departureCity?.cityName || '',
                  locus : {
                    country: metadata?.destinationMeta?.departureCity?.locusDetails?.countryName || '',
                    region: metadata?.destinationMeta?.departureCity?.cityName || '',
                    city: metadata?.destinationMeta?.departureCity?.locusDetails?.locusCode || '',
                    area: [
                      metadata?.destinationMeta?.departureCity?.cityName || ''
                    ]
                  }
                },
                fromDateTime: {
                  ts: date !== '' ? new Date(departureDate).valueOf() : '',
                  zone: '',
                  str: date !== '' ? `${getDate}-${getMonth}-${getFullYear} 00:00:00` : '',
                },
                to: {
                  lobCity: destinationCity,
                  cityName: destinationCity,
                  locusV2Id: metadata?.destinationMeta?.destinationCities?.[0]?.locusDetails?.locusCode || '',
                  locusV2Type: metadata?.destinationMeta?.destinationCities?.[0]?.locusDetails?.locusType || '',
                  name: metadata?.destinationMeta?.destinationCities?.[0]?.cityName || '',
                  lobCountry: metadata?.destinationMeta?.destinationCities?.[0]?.locationDetails?.country || '',
                  countryCode: metadata?.destinationMeta?.destinationCities?.[0]?.locationDetails?.country_code || '',
                  locus : { 
                    country: metadata?.destinationMeta?.destinationCities?.[0]?.locusDetails?.countryName || '',
                    region: metadata?.destinationMeta?.destinationCities?.[0]?.cityName || '',
                    city: metadata?.destinationMeta?.destinationCities?.[0]?.locusDetails?.locusCode || '',
                    area: [
                      metadata?.destinationMeta?.destinationCities?.[0]?.cityName || ''
                    ]
                  }
                },
                expiryDate,
                journeyType: 'OW',
                meta: {
                  description:
                    date !== ''
                      ? `${date?.getDate()} ${date.toLocaleString('default', {
                          month: 'short',
                        })} ${date.getFullYear().toString().substring(2)}`
                      : '',
                  deeplink: window?.location?.href,
                  universalText: `${destinationCity} Holiday Package`,
                },
                lob: 'holidays',
                lobCategory: 'holidays',
                language: 'eng',
                profile: 'PERSONAL',
                region: 'in',
                timestamp: new Date().valueOf(),
                pax: [
                  {
                    count: adultCount + childCount + infantCount || 2,
                    details: {
                      adult: {
                        count: adultCount || 2,
                        ages: null,
                      },
                      child: {
                        count: childCount || 0,
                        ages: null,
                      },
                      infant: {
                        count: infantCount || 0,
                        ages: null,
                      },
                    },
                  },
                ],
              },
            },
          ]);
          if (!(recentSearchData?.aerospike && recentSearchData?.kafka)) {
            throw 'Error';
          }
        } catch (e) {
          console.error(e);
        }
      }
    }
    sendRecentSearch();
  }, [departureDate, packageCount, rooms]);

  const omnitureParams = {};
  omnitureParams.params = getOmniturePageName(LISTING_PAGE_NAME);

  const handleCityChange = (city, fieldName) => {
    if (fieldName === 'fromCity') {
      omniture.captureOmnitureClick('edit_fromCity', omnitureParams);
      setFromCityData({ from: FROM_MANUAL, cityName: city });
    } else {
      omniture.captureOmnitureClick('edit_dest', omnitureParams);
    }
    props.setCityAction(city, fieldName);
  };

  const callLandingMetaData = async () => {
    const urlParams = getUrlParamsMap();
    const params = {
      departure: {
        text: departureCity,
      },
      destination: {
        text: destData.destCity,
      },
    };
    const campaign = destData.campaign || urlParams.campaign;
    if (campaign) {
      params.campaign = campaign;
    }
    const { data } = await getLandingMetaData(params);
    const { dates } = data || {};
    setDateData({ msg: dates?.msg || '', availableDates: dates?.availableDates || {} });
  };
  useEffect(() => {
    if (destinationCity) {
      callLandingMetaData();
    }
  }, [destinationCity]);

  const handleDestChange = cityData => {
    const { childCity = 'NA', childType = 'NA', parentCity = '', parentType = 'NA' } = cityData;
    omniture.captureOmnitureClick('edit_dest', omnitureParams, '', '', {
      prop1: `${parentCity} | ${parentType} | ${childCity} | ${childType}`,
    });
    faOnDestCitySelect({
      city: cityData.destValue,
      cityType: cityData.parentType,
      sectionName: cityData.sectionName,
    });
    setDestData(cityData);
  };

  const handleLocationSearchClick = cityObj => {
    omniture.captureOmnitureClick(
      `reload_${departureCity}_${destinationCity}_${departureDate}`,
      omnitureParams,
      '',
      '',
      { eVar77: getLocationEvarValue(cityObj || fromCityData) }
    );
    gtmClick(TRACK_TYPE.PACKAGE_SEARCH);
    const currentPageQueryParams = getUrlParamsMap();
    let dateSearched;
    if (departureDate) {
      dateSearched = dateFormatter(departureDate, 'DD/MM/YYYY');
    }
    const updatedQueryParam = {
      depCity: cityObj?.cityName ? cityObj?.cityName : departureCity,
      dateSearched,
    };
    const { filters, destCity, campaign, destValue } = destData || {};
    setRecentSearch(destData);
    if (filters && filters.length > 0) {
      filters.forEach(filter => {
        updatedQueryParam[filter?.urlParam] = filter?.values?.join('~');
      });
    }
    if (destValue) {
      updatedQueryParam.dest = destCity;
      updatedQueryParam.destValue = destValue;
    }
    if (campaign) {
      updatedQueryParam.campaign = campaign;
    }
    if (currentPageQueryParams.cmp || currentPageQueryParams.CMP) {
      updatedQueryParam.cmp = currentPageQueryParams.cmp;
    }
    if (currentPageQueryParams.initid || currentPageQueryParams.INITID) {
      updatedQueryParam.initid = currentPageQueryParams.initid;
    }
    if (currentPageQueryParams.glp) {
      updatedQueryParam.glp = currentPageQueryParams.glp;
    }
    if (currentPageQueryParams.pdo) {
      updatedQueryParam.pdo = currentPageQueryParams.pdo;
    }
    if (currentPageQueryParams.version) {
      updatedQueryParam.version = currentPageQueryParams.version;
    }

    updatedQueryParam.affiliate = affiliateDetails.affiliateIdentifier;
    if (paxInfo) updatedQueryParam.rooms = convertRoomForUrl(paxInfo);
    const currentBasePath = '/holidays/india/search';
    const url = `${currentBasePath}?${getQueryStr(updatedQueryParam)}`;
    window.location = url;
  };

  const handleDepartureDateChange = date => {
    faOnDateSelect({ date });
    omniture.captureOmnitureClick('edit_date', omnitureParams);
    props.setTravelDateAction(date);
  };

  const handlePaxChange = pax => {
    const { adultCount, childCount, infantCount } = getTotalPaxCount(pax);
    omniture.captureOmnitureClick('edit_roomsAndGuests', omnitureParams, '', '', {
      prop1: `adults:${adultCount}_children:${childCount}_infant:${infantCount}`,
    });
    faOnPaxSelect(`adults:${adultCount}_children:${childCount}_infant:${infantCount}`);
    setPaxInfo(pax);
  };

  const handleSearchApply = () => {
    const { adultCount, childCount, infantCount } = paxInfo
      ? getTotalPaxCount(paxInfo)
      : getPaxInfo(DEFAULT_SEARCH_PAX_STRING);
    faOnSearchApply({
      fromCity: departureCity,
      destCity: destinationCity,
      date: departureDate,
      pax: `adults:${adultCount}_children:${childCount}_infant:${infantCount}`,
    });
    handleLocationSearchClick('');
  };

  const close = () => {};

  const omnitureCapture = (clickEvent, params) => {
    omniture.captureOmnitureClick(
      clickEvent,
      { params: getOmniturePageName(LISTING_PAGE_NAME) },
      '',
      '',
      params
    );
  };

  const omnitureLoad = (clickEvent, params) => {
    omniture.captureOmnitureOnLoad(
      clickEvent,
      { params: getOmniturePageName(LISTING_PAGE_NAME) },
      '',
      '',
      params
    );
  };
  return (
    <>
      {!modifySearchActive && (
        <div className="searchResponsiveWrapper">
          <div className="editSearchWrapper cursorPointer">
            <div className="makeFlex row hrtlCenter">
              <span className="iconArrow mmt-long-arrow-back" />
              <div className="appendLeft10">
                <p className="font12 darkGreyText">
                  {departureCity || 'New Delhi'} to{' '}
                  <span className="latoBold">{destinationCity || 'Goa'}</span>
                </p>
                <p className="font10 greyText appendTop5">Add date</p>
              </div>
            </div>
            <div className="editIconWrap" onClick={handleMFS}>
              <span className="icon mmt-edit" />
              <p className="font12 blueText appendTop5">Edit</p>
            </div>
          </div>
        </div>
      )}
      {modifySearchActive && (
        <>
          {isMobileDevice() && (
            <div className="editYourSearchWrapper">
              <span className="arrowEditSearch" onClick={handleCloseMFS}>
                ✕
              </span>
              <span className="editYourSearchText">Edit your search</span>
            </div>
          )}
          <ModifySearch fullPage={false} captureOmnitureClick={omnitureCapture}>
            {goeLocationPokus ? (
              <SelectCityWithLocation
                name="fromCity"
                cities={departureCities}
                onClick={close}
                label="STARTING FROM"
                next="dest"
                onNext={faOnFromCityOnNext}
                onFocus={faOnFromCityFocus}
                onSelect={({ name, sectionName, cityType }) =>
                  faOnFromCitySelect({
                    city: name,
                    cityType,
                    sectionName,
                  })
                }
                search={search}
                omnitureCapture={omnitureCapture}
                omnitureLoad={omnitureLoad}
                handleSearchClick={cityObj => {
                  setFromCityData(cityObj);
                  handleLocationSearchClick(cityObj);
                }}
                departureCity={departureCity}
                setCityAction={props.setCityAction}
                setFromCityData={setFromCityData}
                icon={isMobileDevice() ? 'mmt-pin' : ''}
              />
            ) : (
              <SelectCity
                name="fromCity"
                value={departureCity}
                cities={departureCities}
                handleChange={handleCityChange}
                onClick={close}
                label="STARTING FROM"
                next="dest"
                icon={isMobileDevice() ? 'mmt-pin' : ''}
              />
            )}
            <SelectDestination
              name="dest"
              value={destinationCity}
              handleChange={handleDestChange}
              onClick={close}
              onNext={faOnDestCityOnNext}
              onFocus={faOnDestCityFocus}
              onSelect={faOnDestCitySelect}
              asyncSearch
              label="GOING TO"
              next="date"
              departureCity={departureCity}
              icon={isMobileDevice() ? 'mmt-pin-filled' : ''}
            />
            <span />
            <div className="selectRoomsWrapper">
              <SelectDate
                name="date"
                label="STARTING DATE"
                value={departureDate}
                handleChange={handleDepartureDateChange}
                onClick={close}
                onFocus={faOnDateFocus}
                numberOfMonths={isMobile ? 1 : 2}
                destinationCity={destinationCity}
                listingDateData={dateData}
                icon={isMobileDevice() ? 'mmt-calendar' : ''}
              />
            </div>
            {(rooms || getMMT_HLD_OBJ().showPaxOnListing) && (
              <SelectPax
                name="roomsAndGuests"
                value={paxInfo}
                handleChange={handlePaxChange}
                onClick={close}
                onFocus={faOnPaxFocus}
                roomAdditionAllowed
                paxConfig={{}}
                omniture={{ omnitureUtils: omniture, params: omnitureParams }}
                showNewPaxPicker
                closeAfterApply
                icon={isMobileDevice() ? 'mmt-profile' : ''}
              />
            )}
            <button
              className={`primaryBtn big fill btn btn-top-nav btn-lg${
                searchEnabled ? '' : ' disabled'
              }`}
              id="searchBtn"
              onClick={handleSearchApply}
            >
              Search
            </button>
          </ModifySearch>
        </>
      )}
    </>
  );
};

const mapStateToProps = state => {
  const { search, metadata, seoMetadata, groupMetadata } = state;
  const { destinationMeta = {} } = metadata || {};
  const { apWindow = 2 } = destinationMeta || {};
  return {
    search,
    packageCount: metadata?.headerDetail?.totalPackageCount,
    isMobile: seoMetadata?.isMobile,
    groupList: groupMetadata?.groupDetailsList || [],
    apWindow: apWindow,
    metadata,
  };
};

const mapDispatchToProps = {
  setCityAction,
  setTravelDateAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(ModifySearchForm);
